import { Chip, Grid, IconButton, Theme, WithStyles, withStyles } from "@material-ui/core";
import HighlightOff from '@material-ui/icons/Forward';
// import * as moment from "moment";
// import * as moment from "moment";
import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps } from "react-router-dom";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import { ConfigData } from "src/config";
import { IStore } from "src/store";
import { VisitActions } from "src/store/visit/visit-actions";
import { IVisitStore } from "src/store/visit/visit-reducer";
import { WithActions, bindActions, mockTheme } from "src/utils/utils";

const styles = (theme: Theme) => ({
    root: {
        flexGrow: 1,
    },
});

/* function getColorState(state : VisitState) {
  let c = "#000000";
  if (state===VisitState.CREATED){
      c = "#01579b";  
  }
  if (state===VisitState.ASSIGNED){
      c = "#ff9800";  
  }
  if (state===VisitState.IN_PROGRESS){
      c = "#2e7d32";  
  }
  const st: React.CSSProperties ={
      color: c,
      fontWeight: "bold"
  }
  return st;
} */

const classesType = styles(mockTheme);

interface OpportunityListProps
    extends RouteComponentProps<{ id: string }>,
    WithStyles<keyof typeof classesType>,
    WithActions<VisitActions> {
    visit: IVisitStore;
    config: ConfigData;
}

interface OpportunityListState {
    seleccionado?: any,
    fromDate: string;
    toDate: string;
}

export class OpportunityList extends React.Component<OpportunityListProps, OpportunityListState> {

    columnData: ColumnDefinition[] = [
        {
            path: '',
            numeric: true,
            label: 'Acciones',
            draw: (cd: ColumnDefinition, data: any) => {
                return (<div>
                    <Link to={{
                        pathname: `/visit/${data.id}`,
                        state: { data }
                    }}>
                        <IconButton aria-label='Desabilitar' title='Ver'>
                            <HighlightOff />
                        </IconButton>
                    </Link>
                </div>)
            }
        }, {
            path: "id",
            label: "#Id",
            draw: (cd: ColumnDefinition, value: any) => (<div># {value.id}</div>)
        },
        {
            path: "client.user.name",
            label: "Cliente"
        }, {
            path: "visitDateTime",
            label: "Fecha de visita programada",
            draw: (cd: ColumnDefinition, value: any) => {
                // const date = moment(value.visitDateTime, 'YYYY-DD-MM');
                // const formattedDate = date.isValid() ? date.format('DD-MM-YYYY') : '-------';
                return (<span>{value.visitDateTime}</span>)
            }
        },
        {
            path: "visitDate",
            label: "Fecha visitada",
            draw: (cd: ColumnDefinition, value: any) => {
                // const date = moment(value.visitDate, 'YYYY-DD-MM');
                // const formattedDate = date.isValid() ? date.format('DD-MM-YYYY') : '-------';
                return (<span>{value.visitDate}</span>)
            }
        }, {
            path: "state",
            label: "Estado",
            draw: (cd: ColumnDefinition, value: any) => (
                <div
                // style={getColorState(value.state)}
                >
                    {value.visitDate && value.visitDate !== '' && value.visited ? <Chip style={{backgroundColor:'green',color:'white'}} label='Visitado'></Chip> : !value.visitDate && value.visited === false ? <Chip style={{backgroundColor:'orange',color:'white'}} label="Cancelado"></Chip> : <Chip style={{backgroundColor:'blue',color:'white'}} label="Pendiente"></Chip>}
                </div>)
        },
        {
            path: "obs",
            label: "Observación",
        },
        {
            path: "visitReason",
            label: "Razón de visita",
            draw: (cd: ColumnDefinition, value: any) => {
                return (<span>{value.visitReason ? value.visitReason.description : ''}</span>)
                // return (<span>{value.visitDate}</span>)
            },
        },
        {
            path: "branch.name",
            label: "Sucursal"
        }
    ]


    constructor(props: OpportunityListProps) {
        super(props);
        this.props.actions.fetchAll();
    }


    render() {
        return (
            <Grid container spacing={24}>
                <Grid item sm={12} md={12}>
                    <AsyncTable
                        columnDefinition={this.columnData}
                        showFiltro={true}
                        title="Visitas realizadas"
                        data={this.props.visit.all.data}
                        defaultOrder={{
                            name: "branch",
                            direction: "desc"
                        }}
                    />
                </Grid>
            </Grid>);
    }
}

const mapStateToProps = (state: IStore, ownProps: OpportunityListProps) => ({
    ...ownProps,
    visit: state.visit,
    config: state.config.data
});

const styled = withStyles(styles as any)(OpportunityList);
const connected = connect(mapStateToProps, bindActions(VisitActions))(styled);

export default connected as React.ComponentClass<Partial<OpportunityListProps>>;


// WEBPACK FOOTER //
// ./src/pages/opportunityList.tsx